<template>
  <f7-page :page-content="false" hide-bars-on-scroll class="userProfilePage">
    <f7-navbar v-if="profile" no-shadow back-link :title="profile.name">
      <f7-nav-right>
        <f7-nav-right>
          <navbarright></navbarright>
        </f7-nav-right>
      </f7-nav-right>
    </f7-navbar>
    <AppLayout>
      <template #main>
        <f7-toolbar top tabbar  icons>
          <f7-toolbar-pane>
            <f7-link
              icon-ios="f7:person_circle_fill"
              icon-md="material:account_box"
              :text="$t('profile.myDetails')"
              tab-link="#myDetails"
              tab-link-active
            >
            </f7-link>
            <f7-link
              icon-ios="f7:tray_2_fill"
              icon-md="material:account_balance_wallet"
              :text="$t('common.primaryAccount')"
              tab-link="#standardAccount"
            ></f7-link>
            <f7-link
              icon-ios="f7:square_stack_3d_up_fill"
              icon-md="material:account_balance"
              :text="$t('common.businessAccount')"
              tab-link="#businessAccount"
            ></f7-link>
          </f7-toolbar-pane>
        </f7-toolbar>

        <f7-tabs>
          <f7-tab
            id="myDetails"
            tab-active
            class="page-content"
            style="padding-bottom: 50px !important"
          >
            <div v-if="profile" class="avocash-profile-container">
              <!-- Verified Profile Header Badge Card -->
              <div class="avocash-profile-hero-card">
                <div class="avocash-profile-avatar-wrap">
                  <img
                    v-if="userAccount && userAccount.avatar"
                    :src="userAccount?.avatar"
                    class="avocash-profile-avatar-img"
                    :alt="$t('common.a11y.userAvatar')"
                  />
                  <div v-else class="avocash-profile-avatar-placeholder">
                    {{ (profile?.given_name || 'U').charAt(0).toUpperCase() }}
                  </div>
                </div>
                <div class="avocash-profile-hero-info">
                  <h3 class="avocash-profile-name">{{ profile.given_name }} {{ profile.family_name }}</h3>
                  <div class="avocash-profile-status-pill" :class="{ verified: profile.email_verified }">
                    <f7-icon :material="profile?.email_verified ? 'verified' : 'pending'" :size="14" />
                    <span>{{ profile.email_verified ? 'Compte Certifié KYC' : 'En attente de vérification' }}</span>
                  </div>
                </div>
                <button type="button" class="avocash-edit-btn" :aria-label="$t('common.edit')" @click="editProfile()">
                  <f7-icon material="edit" :size="18" />
                </button>
              </div>

              <!-- Personal Information Cards -->
              <div class="avocash-card-group">
                <div class="avocash-card-group-header">
                  <h4 class="avocash-group-title">{{ $t("profile.myPersonalInfo") || 'Informations Personnelles' }}</h4>
                </div>

                <div class="avocash-info-card">
                  <div class="avocash-info-row">
                    <div class="avocash-info-field">
                      <span class="avocash-field-lbl">{{ $t("common.firstName") }}</span>
                      <span class="avocash-field-val">{{ profile.given_name }}</span>
                    </div>
                    <div class="avocash-info-field">
                      <span class="avocash-field-lbl">{{ $t("common.lastName") }}</span>
                      <span class="avocash-field-val">{{ profile.family_name }}</span>
                    </div>
                  </div>

                  <div class="avocash-info-row">
                    <div class="avocash-info-field">
                      <span class="avocash-field-lbl">{{ $t("common.phoneNumber") }}</span>
                      <span class="avocash-field-val">+{{ profile.phoneCode }} {{ profile.phoneNumber }}</span>
                    </div>
                    <div class="avocash-info-field">
                      <span class="avocash-field-lbl">{{ $t("common.email") }}</span>
                      <span class="avocash-field-val">{{ profile.email }}</span>
                    </div>
                  </div>

                  <div class="avocash-info-row">
                    <div class="avocash-info-field">
                      <span class="avocash-field-lbl">{{ $t("common.country") }}</span>
                      <span class="avocash-field-val">{{ profile.address ? profile.address.country : '-' }}</span>
                    </div>
                    <div class="avocash-info-field">
                      <span class="avocash-field-lbl">{{ $t("common.locality") }}</span>
                      <span class="avocash-field-val">{{ profile.address ? profile.address.locality : '-' }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Profile Picture Upload Action -->
              <div
                class="avocash-action-card"
                role="button"
                tabindex="0"
                @click="attachFileOpenActions()"
                @keydown.enter="attachFileOpenActions()"
                @keydown.space.prevent="attachFileOpenActions()"
              >
                <div class="avocash-action-left">
                  <f7-icon material="account_circle" :size="24" class="text-primary" />
                  <div class="avocash-action-text">
                    <span class="avocash-action-title">{{ $t('profile.uploadProfilePicture') }}</span>
                    <span class="avocash-action-sub">Format JPEG, PNG • Max 5 Mo</span>
                  </div>
                </div>
                <f7-icon material="chevron_right" :size="24" class="text-outline" />
              </div>

              <div v-if="documentsUrl && documentsUrl.length > 0" class="avocash-upload-preview margin-top">
                <f7-button
                  raised
                  fill
                  ripple
                  large
                  color="primary"
                  class="buttons"
                  @click="uploadAvatarLogo(userAccount?.standard)"
                >
                  {{ $t("profile.saveProfilePicture") }}
                </f7-button>
              </div>
            </div>
          </f7-tab>
          <f7-tab
            id="standardAccount"
            class="page-content"
            style="padding-bottom: 50px !important"
          >
            <f7-list
              dividers-ios
              v-if="userAccount && userAccount?.standard !== ''"
            >
              <f7-block-title class="padding-left">{{
                $t("common.primaryAccount")
              }}</f7-block-title>

              <f7-list-item
                v-if="userAccount?.standard !== null"
                :header="$t('common.account')"
                :title="userAccount?.standard?.id"
              ></f7-list-item>
              <f7-list-item v-if="userAccount?.standard?.status !== 'ACTIVE'">
                <span>{{ $t("profile.accountIsNotActive") }}</span>
                <f7-toggle
                  class="activeStatus"
                  :disabled="userAccount?.standard?.status !== 'ACTIVE'"
                  color="auto"
                ></f7-toggle>
              </f7-list-item>
              <f7-list-item>
                <span>{{ stdAcctPublicStatus }}</span>
                <f7-toggle
                  class="publicStatus"
                  :checked="userAccount?.stdIsPublic == true"
                  color="auto"
                  @change="publicStatusChange(userAccount?.standard)"
                ></f7-toggle>
              </f7-list-item>
              <f7-block-footer
                style="white-space: normal; word-wrap: break-word"
                >{{ $t("profile.publicAccountCan") }}</f7-block-footer
              >
            </f7-list>
            <f7-list dividers-ios strong-ios simple-list>
              <f7-block-title
                class="display-flex justify-content-space-between margin"
                >{{ $t("profile.paymentLimit")
                }}<span
                  v-html="
                    $filtersToCurrency.toCurrency(
                      paymentLimit,
                      null,
                      userAccount?.currencyCode,
                    )
                  "
                ></span
              ></f7-block-title>
              <f7-list-item>
                <div>
                  <f7-badge>{{ userAccount?.currencyCode }}</f7-badge>
                </div>
                <div style="width: 100%; margin: 0 16px">
                  <f7-range
                    :min="0"
                    :max="100"
                    :step="5"
                    :scale="true"
                    :scale-steps="5"
                    :value="paymentLimit"
                    :label="true"
                    @range:change="onPaymentLimitChange"
                  ></f7-range>
                </div>
                <div>
                  <f7-badge color="auto">{{
                    userAccount?.currencyCode
                  }}</f7-badge>
                </div>
              </f7-list-item>
            </f7-list>
          </f7-tab>
          <f7-tab
            id="businessAccount"
            class="page-content"
            style="padding-bottom: 50px !important"
          >
            <div
              class="business_account_info"
              v-if="userAccount && userAccount?.business !== null"
            >
              <f7-block-title
                style="white-space: normal; word-wrap: break-word"
                v-if="
                  userAccount &&
                  userAccount?.business !== null &&
                  userAccount?.business?.status !== 'ACTIVE'
                "
              >
                {{ $t("profile.businessAccountIs") }}<br />{{
                  $t("profile.pleaseProvideBusiness")
                }}</f7-block-title
              >
              <f7-button
                v-if="
                  userAccount?.business !== null &&
                  userAccount?.business?.status !== 'ACTIVE'
                "
                href="/account/business/activate"
                class="margin buttons"
                fill
                raised
                color="primary"
                large
                >{{
                  $t("businessacceptcash.activateMyBusinessAccount")
                }}</f7-button
              >
              <f7-list
                media-list
                strong-ios
                dividers-ios
                v-if="userAccount?.business !== null"
              >
                <f7-block-title class="padding-left">{{
                  $t("common.businessAccount")
                }}</f7-block-title>
                <f7-link
                  href="/account/business/edit"
                  :style="{ position: 'absolute', right: '16px', top: '-8px' }"
                  icon-ios="f7:pencil"
                  icon-md="material:edit"
                ></f7-link>
                <f7-list-item
                  v-if="userAccount?.business !== null"
                  :header="$t('common.account')"
                  :title="userAccount?.business?.id"
                ></f7-list-item>

                <f7-list-item>
                  <span>{{ businessAcctPublicStatus }}</span>
                  <f7-toggle
                    class="publicStatus"
                    checked
                    color="auto"
                    @change="publicStatusChange(userAccount?.business)"
                  >
                  </f7-toggle>
                </f7-list-item>
                <f7-list-item
                  :header="$t('businessaccountactivate.myCompanyName')"
                  :title="userAccount?.business?.business_info?.name"
                >
                </f7-list-item>
                <f7-list-item
                  :header="$t('businessaccountactivate.myCompanyNumber')"
                  :title="
                    userAccount?.business?.business_info?.registration_number
                  "
                ></f7-list-item>
                <f7-list-item
                  :header="
                    $t('businessaccountactivate.companyActivitydescription')
                  "
                  :title="userAccount?.business?.business_info?.description"
                >
                </f7-list-item>
                <f7-list-item
                  :header="$t('businessaccountactivate.companyPhoneNumber')"
                  :title="'+' + userAccount?.business?.business_info?.phone_number"
                ></f7-list-item>
                <f7-list-item
                  :header="$t('businessaccountactivate.myCompanyEmail')"
                  :title="userAccount?.business?.business_info?.email"
                ></f7-list-item>
                <f7-list-item
                  :header="$t('businessaccountactivate.website')"
                  :title="userAccount?.business?.business_info?.website"
                ></f7-list-item>
                <f7-list-item
                  v-if="userAccount?.business !== null"
                  :header="$t('businessaccountactivate.street')"
                  :title="
                    userAccount?.business?.address?.label1 +
                    ' ' +
                    userAccount?.business?.address?.label2
                  "
                >
                </f7-list-item>
                <f7-list-item
                  v-if="userAccount?.business?.address !== null"
                  :header="
                    $t('common.postCode') + ' ' + $t('common.citylocality')
                  "
                  :title="
                    userAccount?.business?.address?.zip_code +
                    ' ' +
                    userAccount?.business?.address?.city
                  "
                >
                </f7-list-item>
                <f7-list-item
                  @click="attachFileOpenActions()"
                  link="#"
                  class="attachFileButton"
                  :title="$t('profile.uploadLogo')"
                  v-if="
                    userAccount?.logo === null &&
                    documentsUrl &&
                    documentsUrl?.length == 0
                  "
                >
                </f7-list-item>
                <f7-list-item
                  @click="attachFileOpenActions()"
                  class="attachFileButton"
                  v-if="userAccount?.logo !== null"
                  link="#"
                  :title="$t('profile.uploadNewLogo')"
                  ><template #media>
                    <img
                      :src="`${userAccount?.logo}`"
                      v-if="!!userAccount?.logo"
                      style="
                        width: 48px;
                        height: 48px;
                        background-size: cover;
                        display: block;
                      "
                      :alt="$t('common.a11y.businessLogo')"
                  /></template>
                </f7-list-item>

               

                <f7-list-group v-if="avatar == false">
                  <span v-for="(docItem, index) in documentsUrl" :key="index">
                    <f7-list-item
                      :footer="docItem?.fileName"
                      link="#"
                      v-if="docItem?.fileType === 'image' && docItem?.url"
                    >
                      <template #media>
                        <img
                          :src="docItem?.url"
                          v-if="docItem?.fileType === 'image'"
                          style="
                            width: 48px;
                            height: 48px;
                            background-size: cover;
                            display: block;
                            border-radius: 50%;
                          "
                          :alt="$t('common.a11y.userAvatar')"
                      /></template>
                      <template #after>
                        <f7-link
                          v-if="docItem?.fileType === 'image'"
                          raised
                          :style="{
                            right: '60px',
                          }"
                          icon-f7=" pencil_circle"
                          @click="editImage(docItem)"
                        ></f7-link>
                        <f7-link
                          @click="removeDoc(index)"
                          :style="{}"
                          raised
                          color="red"
                          icon-f7="xmark_circle_fill"
                        ></f7-link>
                      </template>
                    </f7-list-item>
                  </span>

                  <f7-button
                    v-if="documentsUrl && documentsUrl?.length > 0"
                    raised
                    fill
                    ripple
                    large
                    color="red"
                    class="margin-top margin-horizontal buttons"
                    @click="uploadAvatarLogo(userAccount?.business)"
                    >{{ $t("common.save") }}
                  </f7-button>
                </f7-list-group>
              </f7-list>
            </div>
          </f7-tab>
        </f7-tabs>
        <editDocs></editDocs>
      </template>
    </AppLayout>
  </f7-page>
</template>
<style scoped>
html.with-panel-right-cover .panel-backdrop-in {
  visibility: none;
  pointer-events: auto;
  opacity: 0;
}

.avocash-profile-container {
  padding: 16px;
}
.avocash-profile-hero-card {
  background: var(--f7-card-bg-color, #fff);
  border-radius: 16px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  border: 1px solid rgba(111, 122, 113, 0.12);
  box-shadow: 0 2px 8px -2px rgba(26, 107, 66, 0.05);
  margin-bottom: 16px;
  position: relative;
}
.avocash-profile-avatar-wrap {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}
.avocash-profile-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.avocash-profile-avatar-placeholder {
  width: 100%;
  height: 100%;
  background: #1A6B42;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--avocash-font-headline, 'Manrope', sans-serif);
  font-size: 22px;
  font-weight: 700;
}
.avocash-profile-hero-info {
  flex: 1;
  min-width: 0;
}
.avocash-profile-name {
  font-family: var(--avocash-font-headline, 'Manrope', sans-serif);
  font-size: 16px;
  font-weight: 700;
  color: #161d18;
  margin: 0 0 4px 0;
}
.avocash-profile-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #edf6ed;
  color: #1A6B42;
  font-family: var(--avocash-font-body, 'Work Sans', sans-serif);
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 9999px;
}
.avocash-edit-btn {
  background: #edf6ed;
  color: #1A6B42;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}

.avocash-card-group {
  margin-bottom: 16px;
}
.avocash-card-group-header {
  margin-bottom: 8px;
}
.avocash-group-title {
  font-family: var(--avocash-font-headline, 'Manrope', sans-serif);
  font-size: 15px;
  font-weight: 700;
  color: #161d18;
  margin: 0;
}
.avocash-info-card {
  background: var(--f7-card-bg-color, #fff);
  border-radius: 16px;
  padding: 16px;
  border: 1px solid rgba(111, 122, 113, 0.12);
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.avocash-info-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.avocash-info-field {
  display: flex;
  flex-direction: column;
}
.avocash-field-lbl {
  font-family: var(--avocash-font-body, 'Work Sans', sans-serif);
  font-size: 11px;
  color: #6f7a71;
}
.avocash-field-val {
  font-family: var(--avocash-font-body, 'Work Sans', sans-serif);
  font-size: 13px;
  font-weight: 600;
  color: #161d18;
  margin-top: 2px;
}

.avocash-action-card {
  background: var(--f7-card-bg-color, #fff);
  border-radius: 14px;
  padding: 14px;
  border: 1px solid rgba(111, 122, 113, 0.12);
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: background 0.15s;
}
.avocash-action-card:active {
  background: #edf6ed;
}
.avocash-action-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.avocash-action-text {
  display: flex;
  flex-direction: column;
}
.avocash-action-title {
  font-family: var(--avocash-font-body, 'Work Sans', sans-serif);
  font-size: 13px;
  font-weight: 600;
  color: #161d18;
}
.avocash-action-sub {
  font-family: var(--avocash-font-body, 'Work Sans', sans-serif);
  font-size: 11px;
  color: #6f7a71;
}
</style>

<script setup>
import AppLayout from "../components/common/AppLayout.vue";
import { ref, computed, onMounted } from "vue";
import { useAccountStore } from "../js/pinia-stores/account.js";
import { useAuthStore } from "../js/pinia-stores/auth.js";
import {useKeycloakStore} from "../js/pinia-stores/keycloak.js";
import {
  useTabletScreen,
  useDesktopScreen,
} from "../js/composables/useMediaQuery.js";

import { f7 } from "framework7-vue";
import navbarright from "../components/navbarright.vue";
import { useAttachDocs } from "../js/composables/useAttachDocs.js";
import { useCordovaCamera } from "../js/composables/useCordovaCamera.js";
import { useTransactAuth } from "../js/composables/useTransactAuth.js";

import editDocs from "../components/editDocs.vue";

import i18n from "../js/i18n.js";
import _ from "lodash";

const props = defineProps({
  f7route: Object,
  f7router: Object,
});

const authStore = useAuthStore();
const accountStore = useAccountStore();
const isTablet = useTabletScreen().matches;
const isDeskTop = useDesktopScreen().matches;
const keycloakStore = useKeycloakStore();

const {
  documentsUrl,
  setAttachment,
  attachFileOpenActions,
  removeDoc,
  editImage,
} = useAttachDocs({ isTablet });

useCordovaCamera({ setAttachment });
const { checkAuth } = useTransactAuth({ f7route: props.f7route, f7router: props.f7router });

const profile = computed(() => authStore.profile ||keycloakStore.profile);
console.log("profile", profile.value);
const user = computed(() => authStore.user||keycloakStore.user);
const document = computed(() => authStore.document);
const userAccount = computed(() => accountStore.userAccount);

const t = i18n.global.t;
const proofOfIdList = ref([
  t("profile.idCard"),
  t("profile.passport"),
  t("profile.residencePermit"),
  t("profile.drivingLicence"),
]);
const expiryDate = ref("");
const proofOfId = ref(t("profile.idCard"));
const documents = ref([]);
const files = ref("");
const paymentLimit = ref(5);
const stdAcctPublicStatus = ref(t("profile.accountIsPublic"));
const businessAcctPublicStatus = ref(t("profile.accountIsPublic"));
const proofOfIdInputvalue = ref("");
const avatar = ref(true);
const fileInput = ref("");
const forms = ref("");

onMounted(() => {
  if (!userAccount.value && keycloakStore.authenticated) {
    profile.value.sub;
  }

  if (
    userAccount.value.stdPaymentLimit != paymentLimit.value ||
    userAccount.value.stdPaymentLimit != 0
  ) {
    paymentLimit.value = userAccount.value.stdPaymentLimit;
  }
  proofOfIdInputvalue.value = f7.$("#proofOfIninput").val();
  authStore.clearDocumentsUrl();
});


function publicStatusChange(account) {
  const toggle = f7.toggle.get(".publicStatus");
  if (toggle.checked) {
    if (account.type === "STANDARD") {
      stdAcctPublicStatus.value = t("profile.accountIsPublic");
    } else {
      businessAcctPublicStatus.value = t("profile.accountIsPublic");
    }
    ({
      accountId: account.id,
      publicAccount: true,
    });
  } else {
    if (account.type === "STANDARD") {
      stdAcctPublicStatus.value = t("profile.accountNotPublic");
    } else {
      businessAcctPublicStatus.value = t("profile.accountNotPublic");
    }
    ({
      accountId: account.id,
      publicAccount: false,
    });
  }
}
function onPaymentLimitChange(values) {
  paymentLimit.value = values;
  console.log("paymentLimit ", values);
  ({
    accountId: userAccount.value.standard.id,
    paymentLimit: values,
  });
}
async function editProfile() {
   await checkAuth({
    intent: { type: "navigate", route: `/user/profile/edit` },
    reason: i18n.global.t("auth.methodPickerHint"),
    onSuccess: () => props.f7router.navigate("/user/profile/edit"),
  });
  
}

async function uploadProofOfId() {
  if (!f7.input.validateInputs(".uploadProofOfId")) {
    return;
  }
  f7.preloader.show("multi");
  forms.value = new FormData();

  for (const content of documentsUrl.value) {
    await forms.value.append("files", content.file);
  }
  await forms.value;
  setTimeout(() => {
    documentsUrl.value = [];
    f7.panel.close(".uploadProofOfIdOpen");
    f7.preloader.hide();
  }, 300);
  authStore.clearDocumentsUrl();
}
async function uploadAvatarLogo(account) {
  if (!account || !documentsUrl.value || documentsUrl.value.length === 0)
    return;

  const isBusiness = account.type === "BUSINESS";
  avatar.value = isBusiness ? false : true;
  const filename = isBusiness ? "logo" : "avatar";
  const doc = documentsUrl.value[0];

  // Set fileName if file exists
  if (doc.file && doc.file.type) {
    doc.fileName = `${filename}.${doc.contentType.split("/")[1]}`;
  }

  // Upload document to R2 if needed
  await {
    shortId: profile.value.sub,
    bucketName: import.meta.env.VITE_R2_PUBLIC_BUCKET_NAME,
  };
  console.log("updated DocumentsUrl", documentsUrl.value[0]);
  const logo = documentsUrl.value[0].url;
  // Update logo/avatar
  if (logo !== null) {
    await {
      accountId: account.id,
      logo,
    };

    authStore.clearDocumentsUrl();
  }
}

function getPicturesAvatar() {
  fileInput.value = "userAvatarInput";
  avatar.value = true;
  getFiles();
}
function getPicturesBusiness() {
  fileInput.value = "businessLogoInput";
  avatar.value = false;
  getFiles();
}
function getPicturesIdProof() {
  fileInput.value = "proofOfIninput";
  getFiles();
}

function getFiles() {
  // Not defined in original mixins - pre-existing issue
}
</script>
